<template>
  <div class="border-t-1 border-solid border-grey-divider-subdued">
    <ul class="mx-auto max-w-max">
      <li v-for="(example, index) in createFlowExamples" :key="index" class="py-16 select-none">
        <ComplexCard
          :variant="cardVariant"
          :headerImageUrl="example.adventureCategoryImage.url"
          :title="example.title"
          :firstLineText="firstLineText(example.category, example.ageRangeText)"
          :minPayRate="example.minPayRate"
          :maxPayRate="example.maxPayRate"
        />
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import ComplexCard from '../../../../components/complex_card/ComplexCard.vue';
import { createFlowExamples } from '@/helpers/exampleAdventures';
import adventures from '@/lib/adventures';

export default {
  name: 'TitleExamples',
  components: { ComplexCard },
  data() {
    return {
      createFlowExamples,
      windowWidth: window.innerWidth,
    };
  },
  computed: {
    cardVariant(): string {
      return this.windowWidth > 375 ? 'active' : 'small';
    },
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    firstLineText(adventureCategory, ageRange): string | null {
      return adventures.getFirstLineText(this.cardVariant, adventureCategory, ageRange);
    },
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
  },
};
</script>
